import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import ReadingTypeService from "../../services/ReadingTypeService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import MessageDialog from "../../components/MessageDialog";


export default function AddReadingType() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const [editMode, setEditMode] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editLoading, setEditLoading] = useState(false); // NEW
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  useEffect(() => {
    if (id) {
      setEditMode(true);
      setIsEdit(id);
      fetchReadingTypeById(id);
    } else {
      setValue("status", "Active");
    }
  }, [id]);

  const fetchReadingTypeById = async (readingId) => {
    setEditLoading(true); //  START LOADING SPINNER
    try {
      const res = await ReadingTypeService.getById(readingId);

      if (res?.data) {
        const record = res.data;

        setValue("readingType", record.readingType || "");
        setValue("status", record.status || "Active");
      } else {
        showMessage("Failed to load Reading Type details.", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("Error fetching Reading Type details.", "error");
    } finally {
      setEditLoading(false);
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let res;

      if (isEdit) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await ReadingTypeService.update(isEdit, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await ReadingTypeService.save({
          ...data,
          status: "Active",
        });
      }

      // SUCCESS CONDITION
      if (res?.status === true) {
        showMessage(
          isEdit
            ? "Reading Type updated successfully."
            : "Reading Type added successfully.",
          "success"
        );

        setTimeout(() => {
          navigate("/cpnl/readingtype/view");
        }, 1000);
      } else {
        // SHOW BACKEND ERROR MESSAGE
        const backendMessage =
          res?.message || "Failed to save Reading Type.";
        showMessage(backendMessage, "error");
      }
    } catch (error) {
      console.error("Error saving reading type:", error);

      const msg =
        error.response?.data?.message ||
        error.message ||
        "Error saving Reading Type";

      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/cpnl/readingtype/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Reading Type" : "Add Reading Type"}
        secondTitle="Masters"
      ></Breadcrumb>

      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
          style={{ borderRadius: "5px" }}
        >
          <span>{message}</span>
          <button type="button" className="btn-close" onClick={closeMessage}></button>
        </div>
      )} */}

      
        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <label className="form-label">
                    Reading Type <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Reading Type"
                    disabled={loading}
                    // {...register("readingType", {
                    //   required: "Reading Type is required",
                    //   minLength: {
                    //     value: 2,
                    //     message: "Minimum 2 characters required",
                    //   },
                    //   pattern: {
                    //     value: /^[A-Za-z0-9\s]+$/,
                    //     message: "Only letters and numbers allowed",
                    //   },
                    // })}

                    {...register("readingType")}
                  />
                  {/* {errors.readingType && (
                    <small className="text-danger">
                      {errors.readingType.message}
                    </small>
                  )} */}
                </div>
              </div>

              <div className="mt-3">
                <button
                  type="submit"
                  className="btn btn-primary me-2"
                  disabled={loading}
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading ? "Saving..." : isEdit ? "Update" : "Save"}
                </button>

                <button
                  type="button"
                  onClick={handleCancel}
                  className="btn btn-secondary"
                  disabled={loading}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
